import * as React from 'react';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { ManufacturerFilterSettingsModel } from "../../../models/manufacturer/manufacturerFilterSettingsModel";
import AlphabeticalFilter from '../../../common/components/alphabeticalFilter/alphabeticalFilter';

interface IProps {
    onSearchClick: any,
    totalRecordsCount: number,
    isVisibleAlphabetic: boolean
}

interface IState {
    manufacturerSettings: ManufacturerFilterSettingsModel,
    selectedType: null,
    selectedGroup: null,
    filterText: string
}

export class ManufacturerFilter extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props);
        this.state = {
            manufacturerSettings: new ManufacturerFilterSettingsModel(),
            selectedType: null,
            selectedGroup: null,
            filterText: ''
        };
    }

    handleAlphaIndexChange = (letter: string) => {
        const currentSettings: ManufacturerFilterSettingsModel = { ...this.state.manufacturerSettings };
        currentSettings.name = '';
        currentSettings.country = '';
        currentSettings.alphaIndex = letter;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            manufacturerSettings: { ...currentSettings },
            filterText: fiterText
        });
        this.handleSearchButtonClick(currentSettings);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const currentSettings: ManufacturerFilterSettingsModel = { ...this.state.manufacturerSettings };
        currentSettings[name] = value;
        const fiterText = this.generateFilterText(currentSettings);
        this.setState({
            manufacturerSettings: { ...currentSettings },
            filterText: fiterText
        });
    }

    generateFilterText = (settings: ManufacturerFilterSettingsModel) => {
        let result = '';

        if (settings.alphaIndex) {
            result += "Start with <strong>'" + settings.alphaIndex + "'</strong>, "
        }
        if (settings.name) {
            result += "Name <strong>'" + settings.name + "'</strong>, "
        }
        if (settings.country) {
            result += "Country <strong>'" + settings.country + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = (settings) => {
        this.props.onSearchClick(settings);
    }

    handleClearButtonClick = () => {
        this.setState({
            manufacturerSettings: new ManufacturerFilterSettingsModel(),
            filterText: ''
        });
        this.handleSearchButtonClick(new ManufacturerFilterSettingsModel());
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSearchButtonClick(this.state.manufacturerSettings)
        }
    }

    render() {
        return (
            <Toolbar style={{ marginBottom: '10px' }}>
                {this.props.isVisibleAlphabetic ?
                    <AlphabeticalFilter
                        handleAlphaIndexChange={this.handleAlphaIndexChange}
                        filters={['en', 'bg']}
                    /> : null}
                <div>
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        name="name"
                        placeholder="Name"
                        onChange={this.handleChange}
                        value={this.state.manufacturerSettings && this.state.manufacturerSettings.name ? this.state.manufacturerSettings.name : ''}
                    />
                    <InputText
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        name="country"
                        placeholder="Country"
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                        onChange={this.handleChange}
                        value={this.state.manufacturerSettings && this.state.manufacturerSettings.country ? this.state.manufacturerSettings.country : ''}
                    />
                </div>
                <div>
                    <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                        Result: <strong>{this.props.totalRecordsCount}</strong>
                        {this.state.filterText ? ', ' : ''}
                        <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                    </div>
                    <div style={{ float: "right" }}>
                        <div>
                            <Button
                                className="p-button-raised"
                                icon="pi pi-filter"
                                style={{ marginRight: "10px" }}
                                label="Filter"
                                onClick={() => this.handleSearchButtonClick(this.state.manufacturerSettings)}
                            />
                            <Button
                                className="p-button-secondary p-button-raised"
                                label="Clear"
                                icon="pi pi-times"
                                onClick={() => this.handleClearButtonClick()}
                            />
                        </div>
                    </div>
                </div>
            </Toolbar>
        )
    }
}

export default ManufacturerFilter;
